import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/resiliency/summary');
  return response.data;
}

export default {
  index,
};
